module.exports = __webpack_public_path__ + "img/p3_r.837018ef.jpg";